import Pagina, { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { Axios } from "@/Services/Axios";
import RequestUtilitario, { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import dayjs, { Dayjs } from "dayjs";

export interface ViagemSintentica {
    codViagem : number,
    nomeEscola : string,
    nomeDestino :string,
    turma :string,
    linkApresentacao ?: string;
    totalInscritos : number,
    totalInscritosPagos : number,
    dataPrazoPagamento : Date,
    dataInicio : Date,
    dataFim : Date,
    valores : Array<string>
}

export interface IViagemSintenticaParam {
    codViagens?: number[],
    intervalo?:[Dayjs,Dayjs]
}

export interface IViagemSintenticaParamComPagina {
    codViagens?: number[],
    intervalo?:[Dayjs,Dayjs],
    paginaInfo : PaginaInfo
}

export function ViagemSintenticaListar({
    codViagens,
    intervalo
}:IViagemSintenticaParam) {
    const queryString = RequestUtilitario.objectToQueryString({
        codViagens : codViagens ?? [],
        dataInicial : intervalo?.[0]?.toDate?.(),
        dataFinal : intervalo?.[1]?.toDate?.()
    });

    return Axios.get<Array<ViagemSintentica>>(`quiron/domain/relatorio/viagem/ViagemSintentico?${queryString}`).then(e => {
        e.data.forEach(m => {
            m.dataInicio = new Date(m.dataInicio as any);
            m.dataFim = new Date(m.dataFim as any);
            m.dataPrazoPagamento = new Date(m.dataPrazoPagamento as any);
        });

        return e.data;
    });
}
export function useViagemSintenticaPagina({
    paginaInfo,
    codViagens,
    intervalo,
    ...rest
}:QueryBasicaParam<AxiosResponse<Pagina<ViagemSintentica>>, Pagina<ViagemSintentica>, IViagemSintenticaParamComPagina>) {
    const queryString = RequestUtilitario.objectToQueryString({
        paginaInfo,
        codViagens : codViagens ?? [],
        dataInicial : intervalo?.[0]?.toDate?.(),
        dataFinal : intervalo?.[1]?.toDate?.()
    });

    return useQuery({
        ...rest,
        queryKey : [ "quiron.domain.relatorio.viagem.ViagemSintentico.pagina", `quiron.domain.relatorio.viagem.ViagemSintentico.pagina?${queryString}` ],
        queryFn : () => Axios.get<Pagina<ViagemSintentica>>(`quiron/domain/relatorio/viagem/ViagemSintentico/pagina?${queryString}`),
        select(data) {
            data.data.registros.forEach(m => {
                m.dataInicio = new Date(m.dataInicio as any);
                m.dataFim = new Date(m.dataFim as any);
                m.dataPrazoPagamento = new Date(m.dataPrazoPagamento as any);
            });

            return data.data;
        },
        staleTime: 1000 * 60 * 0.25
    });
}